import { useState } from "react";
import { Check, X, Loader2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ActionCard({ action, onConfirm, onReject }) {
  const [status, setStatus] = useState(action.status || "pending");
  const [loading, setLoading] = useState(false);

  const handle = async (fn, newStatus) => {
    setLoading(true);
    try {
      await fn(action.id);
      setStatus(newStatus);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div data-testid={`action-card-${action.id}`} className="mt-2 rounded-lg border border-purple-400/40 bg-slate-950/60 backdrop-blur-md p-3">
      <div className="text-[11px] uppercase tracking-wide text-purple-300 font-semibold mb-1">Proposed Change</div>
      <div className="text-sm text-slate-100 mb-2">{action.description}</div>
      {status === "pending" && (
        <div className="flex gap-2">
          <Button
            size="sm"
            disabled={loading}
            onClick={() => handle(onConfirm, "confirmed")}
            data-testid={`approve-ai-action-button-${action.id}`}
            className="bg-emerald-600 hover:bg-emerald-500 h-7 text-xs"
          >
            {loading ? <Loader2 size={12} className="animate-spin mr-1" /> : <Check size={12} className="mr-1" />} Approve
          </Button>
          <Button
            size="sm"
            variant="secondary"
            disabled={loading}
            onClick={() => handle(onReject, "rejected")}
            data-testid={`reject-ai-action-button-${action.id}`}
            className="h-7 text-xs"
          >
            <X size={12} className="mr-1" /> Reject
          </Button>
        </div>
      )}
      {status === "confirmed" && (
        <div className="text-xs text-emerald-400 flex items-center gap-1">
          <Check size={12} /> Applied
        </div>
      )}
      {status === "rejected" && (
        <div className="text-xs text-slate-500 flex items-center gap-1">
          <X size={12} /> Rejected
        </div>
      )}
    </div>
  );
}
